import { defineFunctionalElement, } from 'element-vir';
export const tagPrefix = `toniq-`;
export function defineToniqElement(functionalElementInit) {
    if (!functionalElementInit.tagName.startsWith(tagPrefix)) {
        throw new Error(`Element tag name must start with "${tagPrefix}" (got "${functionalElementInit.tagName}")`);
    }
    if (functionalElementInit.tagName === tagPrefix) {
        throw new Error(`A tag name must exist after the prefix for ${defineToniqElement.name}: "${functionalElementInit.tagName}"`);
    }
    return defineFunctionalElement(functionalElementInit);
}
